import { CollapseUnion } from '@feedyou/utils'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { UserAuthInfo } from './types'
import { AuthResponse } from '../../components/Login/types'

export type UserSliceState = { info: UserAuthInfo }

const initialState: UserSliceState = {
  info: {}
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    receiveAuthResponse: (state, action: PayloadAction<AuthResponse>): any => {
      const { accessToken, tokenLogin = false, idTokenPayload: _idTokenPayload } = action.payload
      const idTokenPayload = _idTokenPayload as CollapseUnion<typeof _idTokenPayload>

      state.info = {
        accessToken,
        tokenLogin,
        id: idTokenPayload?.sub,
        name: idTokenPayload?.name,
        email: idTokenPayload?.email,
        verifiedEmail: idTokenPayload?.email_verified,
        picture: idTokenPayload?.picture
      }
    },
    setIsEnabledDailyCommentSummary: (state, action: PayloadAction<boolean>): void => {
      state.info.isEnabledDailyCommentSummary = action.payload
    }
  }
})

export const userActions = userSlice.actions
export const userReducer = userSlice.reducer
